<div class="task-items-table-container">
    <table mat-table [dataSource]="taskItems" class="mat-elevation-z0" style="width: 100%">

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>ID</th>
            <td mat-cell *matCellDef="let item">{{ item.Id }}</td>
        </ng-container>

        <ng-container matColumnDef="gridicsId">
            <th mat-header-cell *matHeaderCellDef>Gridics ID</th>
            <td mat-cell *matCellDef="let item">{{ item.GridicsId }}</td>
        </ng-container>

        <ng-container matColumnDef="folioNumber">
            <th mat-header-cell *matHeaderCellDef>Folio Number</th>
            <td mat-cell *matCellDef="let item">{{ item.FolioNumber }}</td>
        </ng-container>

        <ng-container matColumnDef="groupId">
            <th mat-header-cell *matHeaderCellDef>Group ID</th>
            <td mat-cell *matCellDef="let item">{{ item.GroupId }}</td>
        </ng-container>

        <ng-container matColumnDef="oldGridicsId">
            <th mat-header-cell *matHeaderCellDef>Old Gridics ID</th>
            <td mat-cell *matCellDef="let item">{{ item.OldGridicsId }}</td>
        </ng-container>

        <ng-container matColumnDef="taskId">
            <th mat-header-cell *matHeaderCellDef>Task ID</th>
            <td mat-cell *matCellDef="let item">{{ item.TaskId }}</td>
        </ng-container>

        <ng-container matColumnDef="metaData">
            <th mat-header-cell *matHeaderCellDef>Metadata</th>
            <td mat-cell *matCellDef="let item" class="metadata-cell">
                <pre *ngIf="item.MetaData" class="metadata-content">{{ item.MetaDataStr }}</pre>
                <span *ngIf="!item.MetaData">-</span>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div *ngIf="!taskItems || taskItems.length === 0" class="no-data-message">
        <p>No task items to display</p>
    </div>
</div>